import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {PermissionsService} from '../../../shared/services/permissions.service';
import {PermissionsConfig} from '../../../shared/interface/permissions-config';
import {FormBuilder, FormGroup, NgForm} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-permissions',
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.scss']
})
export class PermissionsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  permissionsConfig: PermissionsConfig;

  @Input() permissionsForm?: FormGroup;
  @Input() currentPermissions: any;
  @Input() disabled = false;

  constructor(
    private permissionsService: PermissionsService,
    private fb: FormBuilder,
  ) {

  }

  ngOnInit(): void {
    if (!this.permissionsForm) {
      this.permissionsForm = this.fb.group({});
    }

    this.permissionsService.getPermissionsConfig()
      .subscribe((permissionsConfig: PermissionsConfig) => {

        permissionsConfig.permissions.forEach((permission) => {
          this.permissionsForm.addControl(
            permission.module,
            this.fb.control(this.currentPermissions[permission.module] ?? 'none')
          );
        });

        this.permissionsConfig = permissionsConfig;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

}
